<template>

  <div class="group" style="margin-bottom: 0;" data-id="widthGroup" v-if="currentPrepareItem">

    <div class="group-header" style="margin-top: 20px;">
      <div class="group-title">{{ wardrobeName(currentPrepareItem.item, builder.prepareItemIndex) }}</div>
      <div class="group-help" v-if="builder.prepareItems.length > 1">
        Wardrobe {{ builder.prepareItemIndex + 1 }} of {{ builder.prepareItems.length }}
      </div>
    </div>

    <div class="group-header" style="margin-top: 20px;">
      <div class="group-title">Levels Measurements</div>
      <div class="group-help"><a href="/support/how-to-measure/" target="_blank">View levels measurement guide.</a></div>
    </div>

    <div class="group-footer" style="font-size: 80%;">

      <p>You're being asked for additional measurements because your selected levels were out by more than 8mm. We must get these measurements to ensure the doors fit correctly, and we can supply additional scribes if needed.</p>

    </div>

    <div class="group-footer l_text-center">

      <div class="styledcheckbox group-checkbox">
        <input
          type="checkbox"
          :name="fieldName(currentPrepareItem.item, 'standardLevels')"
          :id="fieldName(currentPrepareItem.item, 'standardLevels')"
          value="1"
          :true-value="true"
          :false-value="false"
          v-model="useStandardLevels" />
        <label :for="fieldName(currentPrepareItem.item, 'standardLevels')">
          <span class="checkbox-value">Please process my order at standard levels measurements without providing additional measurements below.</span>
        </label>
      </div>

    </div>

    <template v-if="!useStandardLevels">

    <div class="group-header" style="margin-top: 20px;">
      <div class="builderinput-label l_measurement-label l_base-color">Widths</div>
    </div>

    <div class="group-inputs">

      <div class="group-input">

        <Input
        :key="fieldKey(currentPrepareItem.item, 'widthTop')"
        field-label="Top Width"
        :field-name="fieldName(currentPrepareItem.item, 'widthTop')"
        field-type="number"
        :init-value=currentPrepareItem.item.specs.widthTop
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="(prop, val) => updateValue(currentPrepareItem.itemIndex, 'widthTop', val)"
        ></Input>

      </div>

      <div class="group-input">

        <Input
        :key="fieldKey(currentPrepareItem.item, 'widthMiddle')"
        field-label="Middle Width"
        :field-name="fieldName(currentPrepareItem.item, 'widthMiddle')"
        field-type="number"
        :init-value=currentPrepareItem.item.specs.widthMiddle
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="(prop, val) => updateValue(currentPrepareItem.itemIndex, 'widthMiddle', val)"
        ></Input>

      </div>

      <div class="group-input">

        <Input
        :key="fieldKey(currentPrepareItem.item, 'widthBottom')"
        field-label="Bottom Width"
        :field-name="fieldName(currentPrepareItem.item, 'widthBottom')"
        field-type="number"
        :init-value=currentPrepareItem.item.specs.widthBottom
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="(prop, val) => updateValue(currentPrepareItem.itemIndex, 'widthBottom', val)"
        ></Input>

      </div>

    </div>

    <div class="group-header" style="padding-top: 20px; border-top: 2px solid #ccc; margin-top: 20px;">
      <div class="builderinput-label l_measurement-label l_base-color">Heights</div>
    </div>

    <div class="group-inputs" style="margin-top: 20px;">

      <div class="group-input">

        <Input
        :key="fieldKey(currentPrepareItem.item, 'heightLeft')"
        field-label="Left Height"
        :field-name="fieldName(currentPrepareItem.item, 'heightLeft')"
        field-type="number"
        :init-value=currentPrepareItem.item.specs.heightLeft
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="(prop, val) => updateValue(currentPrepareItem.itemIndex, 'heightLeft', val)"
        ></Input>

      </div>

      <div class="group-input">

        <Input
        :key="fieldKey(currentPrepareItem.item, 'heightMiddle')"
        field-label="Middle Height"
        :field-name="fieldName(currentPrepareItem.item, 'heightMiddle')"
        field-type="number"
        :init-value=currentPrepareItem.item.specs.heightMiddle
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="(prop, val) => updateValue(currentPrepareItem.itemIndex, 'heightMiddle', val)"
        ></Input>

      </div>

      <div class="group-input">

        <Input
        :key="fieldKey(currentPrepareItem.item, 'heightRight')"
        field-label="Right Height"
        :field-name="fieldName(currentPrepareItem.item, 'heightRight')"
        field-type="number"
        :init-value=currentPrepareItem.item.specs.heightRight
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="(prop, val) => updateValue(currentPrepareItem.itemIndex, 'heightRight', val)"
        ></Input>

      </div>

    </div>

    <div class="group-header" style="padding-top: 20px; border-top: 2px solid #ccc; margin-top: 20px;">
      <div class="builderinput-label l_measurement-label l_base-color">Run-out</div>
    </div>

    <div class="group-inputs">

      <div class="group-input">

        <Select-Input
        :key="fieldKey(currentPrepareItem.item, 'runOutDirection')"
        field-label="Direction"
        :field-name="fieldName(currentPrepareItem.item, 'runOutDirection')"
        field-type="select"
        show-label="true"
        :init-value=currentPrepareItem.item.specs.runOutDirection
        :default-value="builder.runOutDirectionsOptions[0].id"
        :required="true"
        options-source="runOutDirectionsOptions"
        custom-class="builderinput l_measurement"
        scope="specs"
        @update-value="(prop, val) => updateValue(currentPrepareItem.itemIndex, 'runOutDirection', val)"
        ></Select-Input>

      </div>

      <div class="group-input">

        <Input
        :key="fieldKey(currentPrepareItem.item, 'runOutAmount')"
        field-label="Amount"
        :field-name="fieldName(currentPrepareItem.item, 'runOutAmount')"
        field-type="number"
        :init-value=currentPrepareItem.item.specs.runOutAmount
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="(prop, val) => updateValue(currentPrepareItem.itemIndex, 'runOutAmount', val)"
        ></Input>

      </div>

    </div>

    </template>

    <!-- <div class="group-footer l_text-center" v-if="builder.currentItem.specs.levelsOut">

      <img src="/images/wardrobe-levels-measure-guide.svg" style="width: 100%; max-width: 500px; margin: 0 auto;">

    </div> -->

  </div>

</template>

<script setup>

import { computed, watch } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const requiredFields = [
  'widthTop',
  'widthMiddle',
  'widthBottom',
  'heightLeft',
  'heightMiddle',
  'heightRight',
  'runOutDirection',
  'runOutAmount'
];

const currentPrepareItem = computed(() => {
  return builder.currentPrepareItem;
});

const useStandardLevels = computed({
  get() {
    return builder.currentPrepareUsesStandardLevels;
  },
  set(value) {
    if (!currentPrepareItem.value) return;
    const prepareItemKey = currentPrepareItem.value.item.id ?? currentPrepareItem.value.item.ref;
    if (value && !builder.prepareStandardLevelsItemKeys.includes(prepareItemKey)) {
      builder.prepareStandardLevelsItemKeys.push(prepareItemKey);
    } else if (!value) {
      builder.prepareStandardLevelsItemKeys = builder.prepareStandardLevelsItemKeys.filter((key) => {
        return key !== prepareItemKey;
      });
    }
  }
});

function fieldKey(item, prop) {
  return `${item.id ?? item.ref}-${prop}`;
}

function fieldName(item, prop) {
  return `prepare-${item.id ?? item.ref}-${prop}`;
}

function wardrobeName(item, index) {
  if (item.label) return item.label;
  if (item.ref) return `Wardrobe ${item.ref}`;
  return `Wardrobe ${index + 1}`;
}

function updateValue(itemIndex, prop, val) {
  if (!builder.items[itemIndex].specs || typeof builder.items[itemIndex].specs !== 'object') {
    builder.items[itemIndex].specs = {};
  }
  builder.items[itemIndex].specs[prop] = val;
}

function hasValue(value) {
  return value !== null && value !== undefined && value !== '';
}

const isPrepareComplete = computed(() => {
  return builder.prepareItems.length > 0 && builder.prepareItems.every(({ item }) => {
    const prepareItemKey = item.id ?? item.ref;
    if (builder.prepareStandardLevelsItemKeys.includes(prepareItemKey)) return true;
    return requiredFields.every((field) => hasValue(item.specs[field]));
  });
});

watch(isPrepareComplete, (value) => {
  builder.isPrepareComplete = value;
}, { immediate: true });

watch(() => builder.prepareItems.length, (length) => {
  if (length && builder.prepareItemIndex > length - 1) builder.prepareItemIndex = length - 1;
});
</script>
